module.exports = __webpack_public_path__ + "img/acolman.22478eb1.jpg";